<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SCsqG7/tc-custom/9781911420491.jpg?1724535926064" alt="This image is the cover for the book Insurrection, An Agent Paul Richter Thriller"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Insurrection, An Agent Paul Richter Thriller
      </h1>
      <p class="bookDescription body article font2">
        <p>  <b>An action-packed espionage techno-thriller featuring a British intelligence agent who must stop a terrorist attack on the United States.</b><br/>  <br/> Maverick British agent Paul Richter returns in his most dangerous mission yet.<br/>  <br/> In Syria, a ritualistic ISIS beheading seems like another barbaric part of a terrible war. But this time is different . . .<br/>  <br/> In London, Paul Richter is briefed about a series of apparently unconnected events, notably a terrifying spate of seemingly random shootings in America. Something doesn’t quite fit. Before long Richter is on the case and in the line of fire.<br/>  <br/> It seems a plot far bigger than anyone could have imagined is brewing from the mountains of the Hindu Kush and the deserts of Syria to the heart of Middle America.<br/>  <br/> With no information, the clock is ticking for Richter—and millions of innocent lives.<br/>  <br/> For readers of James Patterson, Will Jordan and Chris Ryan, the Agent Paul Richter series is intense, visceral and totally unmissable.<br/>   </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Barrington
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Digital Publishing Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?547329d4